import get from 'lodash.get';

const getIntegrations = (rootState) => get(rootState, 'ws.site.meta.integrations', {});

export default getIntegrations;
